/** 策略参数表单（F-009）：由策略的 ParamField[] 描述符生成，无 zod 内部 API 依赖。 */
import type { ParamField, StrategyParams } from '../../strategy/strategy-api';

interface Props {
  fields: readonly ParamField[] | undefined;
  value: StrategyParams;
  onChange: (p: StrategyParams) => void;
}

export function ParamForm({ fields, value, onChange }: Props) {
  if (!fields || fields.length === 0) return <div className="text-xs text-slate-500">该策略无可调参数。</div>;

  return (
    <div className="space-y-2">
      {fields.map((f) => {
        const v = typeof value[f.key] === 'number' ? (value[f.key] as number) : f.default;
        return (
          <label key={f.key} className="block text-sm">
            <span className="text-slate-300">{f.label}</span>
            <input
              type="number"
              step={f.step ?? 'any'}
              min={f.min}
              max={f.max}
              value={v}
              onChange={(e) => onChange({ ...value, [f.key]: Number(e.target.value) })}
              className="mt-0.5 w-full bg-slate-800 border border-slate-700 rounded-md px-2 py-1 text-slate-100"
            />
          </label>
        );
      })}
    </div>
  );
}
